import React from 'react';
import { alpha, styled } from '@mui/material/styles';

const SectionContainer = styled('div')(({ theme, ...props }) => ({
    width: 'calc(100% - 30px)',
    paddingLeft: '15px',
    paddingRight: '15px',
    ...(!props?.disableTopPadding ? {paddingTop: props?.paddingTop ? `${props?.paddingTop}px` : '64px'} : {}),
    ...(!props?.disableBottomPadding ? {paddingBottom: props?.paddingBottom ? `${props?.paddingBottom}px` : '64px'} : {}),
    marginLeft:'auto',
    marginRight:'auto',

    '@media (min-width: 576px)': {
        maxWidth:'540px'
    },

    '@media (min-width: 768px)': {
        maxWidth:'720px'
    },

    '@media (min-width: 992px)': {
        maxWidth:'960px'
    },

    '@media (min-width: 1200px)': {
        maxWidth:'1140px'
    },

    '@media (min-width: 1400px)': {
        maxWidth:'1320px'
    }
}));

function SectionLayout({children, paddingLeft, paddingRight, paddingTop, paddingBottom, disableTopPadding=false, disableBottomPadding=false, ...other}) {

    return (
        <SectionContainer
            {...other}
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            paddingTop={paddingTop}
            paddingBottom={paddingBottom}
            disableTopPadding={disableTopPadding}
            disableBottomPadding={disableBottomPadding}
        >
            {children}
        </SectionContainer>
    )
};

export default SectionLayout;